'use strict';

const airlinesUtils = require('../../../modules/utils/airlines');
const seatsUtils = require('../../../modules/seats/utils');
const templatesUtils = require('../utils/templatesUtils');
const isDynpack = Odigeo.Utils.isRequestApp('dp');
const fillBookingRatingText = function(obj, options) {
    obj.text = options.bookingRatingTexts ? options.bookingRatingTexts[Odigeo._.camelCase(obj.type)] : '';
};
const {isOneSegmentPerLegDesktopEnabled, isResultsBoxRevampDesktop} = Odigeo.AB;

const createdSelectedInfo = function(item, segItem) {
    const isSegmentSelected = item.flightPreselectedId === item.mainItineraryId &&
        Odigeo._.includes([item.flightOutboundPreselectedNumber, item.flightInboundPreselectedNumber], segItem.flightNumbers);
    return {
        isSegmentSelected,
        isItinerarySelected: item.flightPreselectedId === item.mainItineraryId,
        hasToBeSegmentCheck: isDynpack && isSegmentSelected,
        selectedSegmentClass: isSegmentSelected ? 'active-row' : '',
    };
};
const createBaggageIncludedInfo = function(model, translations) {
    const {includedType, hoverMessage, smallBagOnly} = model.baggage;
    const isBaggageIncluded = includedType === 'CHECK_IN_INCLUDED';
    const smallBagInCabinMessage = translations.smallBaggageMessage;
    const isCarrierWithSmallBagInCabin = airlinesUtils.isCarrierWithSmallBagInCabin(model.carrierCode) || !!smallBagOnly;
    let message = translations.handBaggageIncludedMessage;

    const baggageIcon = isBaggageIncluded ? 'odf-icon-checkin-baggage' : 'odf-icon-baggage';

    if (isBaggageIncluded) {
        message = translations.baggageIncludedMessage;
    }

    const styleClass = {
        CHECK_IN_INCLUDED: 'odf-text-positive',
        CABIN_INCLUDED: '',
        UNKNOWN: 'odf-hidden',
    }[includedType];

    return {
        status,
        styleClass,
        hoverMessage,
        icon: baggageIcon,
        message: isCarrierWithSmallBagInCabin ? smallBagInCabinMessage : message,
        showToolTip: model.showToolTip,
    };
};
const createStopInfo = function(model) {
    const stops = [];
    const sections = model.sections;
    const addStop = function(stopModel) {
        stops.push({
            duration: stopModel.stopDurationFormated,
            iata: stopModel.departureCityIata,
            airport: stopModel.departureAirport,
            city: stopModel.departureCity,
        });
    };

    Odigeo._.each(sections[0].techStops, addStop);
    for (let stopsIndex = 1; stopsIndex <= model.numStops; stopsIndex++) {
        addStop(sections[stopsIndex]);
        Odigeo._.each(sections[stopsIndex].techStops, addStop);
    }

    return stops;
};

const isDepartureLessThan48HoursAhead = function(departureInfo) {
    const daysToCompare = 3;
    const differenceInDays = Odigeo.Utils.getDifferenceInDays(
        new Date().getTime(),
        new Date(departureInfo.jsFormattedDate + ' ' + departureInfo.time).getTime()
    );

    return differenceInDays < daysToCompare;
};

const processSections = function(segItem, templates, widgetOptions) {
    let sectionsStopsContent = '';
    let segItemStopCarriersInfoHtml = '';
    let stopsDurations = '';
    let hasPreviousStop = false;
    let section;

    for (let sectionIndex = 0; sectionIndex < segItem.sections.length; sectionIndex++) {
        section = segItem.sections[sectionIndex];

        if (templates.segmentSectionStop && sectionIndex > 0) {
            sectionsStopsContent += templatesUtils.template(templates.segmentSectionStop)({
                departureCity: section.departureCity,
                stopStyle: (section.stopDuration !== 0) ? '' : 'style="display:none"',
                stopDurationFormated: section.stopDurationFormated,
                hasPreviousStop: hasPreviousStop,
            });

            stopsDurations += section.stopDurationFormated + ' ' + widgetOptions.translations.and + ' ';
            hasPreviousStop = true;
        }

        if (templates.segmentSectionStopCarrier && section.carrierName) {
            segItemStopCarriersInfoHtml += templatesUtils.template(templates.segmentSectionStopCarrier)({
                carrierName: section.carrierName,
                hasPreviousCarrier: false,
            });
        }
    }

    return {
        sectionsStopsContent,
        segItemStopCarriersInfoHtml,
        stopsDurations: stopsDurations.substr(0, stopsDurations.length - 2 - widgetOptions.translations.and.length),
    };
};

module.exports = Backbone.View.extend({
    initialize: function(options) {
        this.template = options.segmentItemTemplate;

        const {segItem, itGroup, item, data, widgetOptions} = options;
        const isTouchable = Odigeo.Device.navigator.isTouchable();

        fillBookingRatingText(item.odiRating.bookingRating, widgetOptions);
        const {stopsDurations, sectionsStopsContent, segItemStopCarriersInfoHtml} = processSections(segItem,
            options.sectionTemplates, widgetOptions);

        const logosHtml = this.buildLogosHtml(itGroup.allAirlineImageIcons, options.sectionTemplates);
        const departureInfoType = segItem.departureInfo.type || '';
        const arrivalInfoType = segItem.arrivalInfo.type || '';
        this.templateData = {
            isTouchable,
            segItemStopCarriersInfoHtml,
            stopsDurations,
            sectionsStopsContent,
            iterCountIndex: segItem.iterCountIndex,
            isEmptyDeparture: segItem.isEmptyDeparture,
            searchDepartureCity: data.searchDepartureCity,
            isEmptyArrival: segItem.isEmptyArrival,
            searchArrivalCity: data.searchArrivalCity,
            lastItineraryGroup: options.lastItineraryGroup,
            departureInfo: segItem.departureInfo,
            departureInfoType: departureInfoType.toLowerCase(),
            arrivalInfoType: arrivalInfoType.toLowerCase(),
            arrivalInfo: segItem.arrivalInfo,
            arrivalDateDifferentFormatted: segItem.arrivalDateDifferentFormatted,
            carrierCode: segItem.carrierCode,
            logos: logosHtml,
            carrierName: itGroup.carrierName,
            segmentType: segItem.segmentType,
            isCharter: segItem.isCharter,
            charterWarningDates: segItem.charterWarningDates,
            charterWarningHours: segItem.charterWarningHours,
            segmentDuration: segItem.segmentDuration,
            segmentDurationFormated: segItem.segmentDurationFormated,
            isLongHaul: segItem.isLongHaul,
            numStops: segItem.numStops,
            numAllStops: segItem.numAllStops,
            operatingAirlineText: data.operatingAirlineText,
            hideCheckboxes: data.hideCheckboxes,
            count: itGroup.count,
            segmentId: segItem.segmentId,
            showDetails: data.showDetails,
            arrivalText: data.arrivalText,
            departureText: data.departureText,
            differenceInDays: segItem.differenceInDays,
            airlineText: data.airlineText,
            airlineImageIcon: itGroup.airlineImageIcon,
            flightNumbers: segItem.flightNumbers,
            multipleAirlinesText: data.multipleAirlinesText,
            itineraryDetailsLoadingText: data.itineraryDetailsLoadingText,
            itineraryDetailsId: data.itineraryDetailsId,
            mainItineraryId: item.mainItineraryId,
            isNativeInput: options.isNativeInput,
            isOneSegmentPerLegDesktopEnabled,
            isResultsBoxRevampDesktop,
            searchType: data.searchType,
            isChangeFlightFreeChargeValid: options.isChangeFlightFreeChargeValid,
            flightChangeFreeClass: options.flightChangeFreeClass,
            flightChangeEligibleClass: options.flightChangeEligibleClass,
            priceNextCtaEnabled: options.priceNextCtaEnabled,
            isLoggedInPrimeMember: options.isLoggedInPrimeMember,
            membershipPriceDisplayDesktop: Odigeo.Membership.membershipPriceDisplayDesktop,
            isHubItinerary: itGroup.isHubItinerary,
            isSmartHubItinerary: itGroup.isSmartHubItinerary,
            isSameIATAAirline: itGroup.isSameIATAAirline,
            translations: widgetOptions.translations,
            tests: widgetOptions.tests,
            searchId: item.fareItinerarySearchId,
            pluralizeAll: Odigeo.Utils.pluralizeAll,
            opCarrierName: segItem.sections[0].carrierName,
            freeCancellationHoursApart: item.freeCancellationHoursApart,
            isFreeCancellationEnabled: widgetOptions.isFreeCancellation,
            bookingRating: item.odiRating.bookingRating,
            cssClassesForOsplAndDp: isOneSegmentPerLegDesktopEnabled && isDynpack
                ? '  od-remove-checkbox-change-display-dp odf-space-outer-left-s ' : '',
            segmentClasses: isTouchable || isOneSegmentPerLegDesktopEnabled
                ? '' : 'od-resultpage-segment-itinerary-row-hover',
            itDurationStyle: (segItem.segmentDuration === 0) ? 'style="display:none"' : '',
            numStopsColorClass: (segItem.numAllStops === 0 && !widgetOptions.tests.newResultCardEnabled) ? 'odf-text-positive' : '',
            selectedInfo: createdSelectedInfo(item, segItem),
            stopsInfo: createStopInfo(segItem),
            oneSegmentPerLegEnabled: widgetOptions.tests.oneSegmentPerLegEnabled,
            showRadios: itGroup.segItems.length > 1,
            showOperatingCarrier: data.showOperatingCarrier && !Odigeo._.isEmpty(segItem.sections[0].carrierName),
            baggage: createBaggageIncludedInfo({
                baggage: segItem.baggage,
                baggageWeightMessage: segItem.baggageWeightMessage,
                carrierCode: segItem.carrierCode,
                showToolTip: widgetOptions.baggage.showToolTip,
                opCarrierName: segItem.sections[0].carrierName,
                departureShortDate: segItem.departureInfo.jsFormattedDate,
            }, widgetOptions.translations.baggage, widgetOptions.tests),
            seatsLeft: seatsUtils.toDefaultTemplateData({
                numSeatsLeft: segItem.numSeatsLeft,
                numPassengers: data.numPassengers,
            }, data.translations.seatsLeft, widgetOptions),
            stopsMsgText: (segItem.numStops > 1) ? data.stopsMsgText : data.stopMsgText,
            hasStopCarriersInfo: !!segItemStopCarriersInfoHtml,
            differenceInDaysMessage: Odigeo.Utils.pluralizeAll(
                widgetOptions.translations.differentDaysPlural,
                segItem.differenceInDays),
            isCarrierLowCost: (data.isShowLcInsteadOfIcon && segItem.providerCode === 'TF' &&
                (itGroup.carrierCode === 'VY' || itGroup.carrierCode === 'FR' || itGroup.carrierCode === 'U2')),
            aircraftText: (itGroup.transportType === 'TRAIN' || itGroup.transportType === 'MIX_PLANE_TRAIN' ? segItem.aircraftText : ''),
            isRefundableFareUpgradeApplicable: !options.isTrain && !isDepartureLessThan48HoursAhead(segItem.departureInfo),
            indexWithinItineraryGroup: segItem.indexWithinItineraryGroup,
            transportType: itGroup.transportType,
            airlineLogos: Odigeo._.uniq(itGroup.allAirlineImageIcons),
            resultSegmentName: itGroup.resultSegmentName,
            isTrainCard: data.isTrainCard,
            isVinFlight: (!itGroup.isSameIATAAirline && itGroup.isSmartHubItinerary) || (!itGroup.isSameIATAAirline && itGroup.isHubItinerary),
            multipleCarriersText: data.multipleCarriersText,
            isFromMeta: item.isFromMetaSearch,
        };
    },
    render: function() {
        this.$el.html(this.template(this.templateData));
        return this;
    },
    buildLogosHtml(icons, templates) {
        const iconUrls = icons || [];
        const logosNumberLimit = 2;
        return iconUrls.filter((icon, index) => iconUrls.indexOf(icon) === index)
            .slice(0, logosNumberLimit)
            .reduce((list, logo) => list + templatesUtils.template(templates.singleLogo)({logo}), '');
    },
});
